import { render, staticRenderFns } from "./slot-prop-user.vue?vue&type=template&id=31607b4e&"
import script from "./slot-prop-user.vue?vue&type=script&lang=js&"
export * from "./slot-prop-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports